export const config = () => window['CONFIG'];

export const initConfig = config => (window['CONFIG'] = config);

export const setConfigItem = (key, value) => (window['CONFIG'][key] = value);
